<div class="flex items-center justify-end gap-3 mb-3">
  <a routerLink="/settings/business-hours"
    class="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-white/[0.03] sm:w-auto">
    <svg xmlns="http://www.w3.org/2000/svg" class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
    Horarios del negocio
  </a>
  <button (click)="onNewAgenda()"
    class="flex w-full items-center justify-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white shadow-theme-xs hover:bg-brand-600 sm:w-auto">
    <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.2502 4.99951C9.2502 4.5853 9.58599 4.24951 10.0002 4.24951C10.4144 4.24951 10.7502 4.5853 10.7502 4.99951V9.24971H15.0006C15.4148 9.24971 15.7506 9.5855 15.7506 9.99971C15.7506 10.4139 15.4148 10.7497 15.0006 10.7497H10.7502V15.0001C10.7502 15.4143 10.4144 15.7501 10.0002 15.7501C9.58599 15.7501 9.2502 15.4143 9.2502 15.0001V10.7497H5C4.58579 10.7497 4.25 10.4139 4.25 9.99971C4.25 9.5855 4.58579 9.24971 5 9.24971H9.2502V4.99951Z"
        fill=""></path>
    </svg>
    Nueva Agenda
  </button>
</div>
<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 xl:grid-cols-4">
  <!-- Card -->
  <div class="group relative overflow-hidden rounded-2xl border border-gray-200 bg-white px-6 pb-5 pt-6
           transition-shadow hover:shadow-md
           dark:border-gray-800 dark:bg-white/[0.03]" *ngFor="let a of agendas(); trackBy: trackById">

    <div class="mb-6 flex items-center gap-3">
      <div class="h-10 w-10 rounded-full" [style.backgroundColor]="a.color"></div>
      <div>
        <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ a.name }}</h3>
        <span class="block text-theme-xs text-gray-500 dark:text-gray-400">{{ a.description }}</span>
      </div>
    </div>

    <!-- Acciones -->
    <div class="mt-2 flex items-center gap-3
             sm:mt-4
             md:absolute md:inset-x-0 md:bottom-0 md:p-3
             md:bg-gradient-to-t md:from-white/95 md:via-white/70 md:to-transparent
             md:backdrop-blur-sm
             md:opacity-0 md:translate-y-3 md:pointer-events-none
             md:transition-all md:duration-200 md:ease-out
             group-hover:md:opacity-100 group-hover:md:translate-y-0 group-hover:md:pointer-events-auto
             focus-within:md:opacity-100 focus-within:md:translate-y-0 focus-within:md:pointer-events-auto
             dark:md:from-gray-900/95 dark:md:via-gray-900/60">

      <button class="flex w-full items-center justify-center gap-1 rounded-lg border border-gray-300 bg-white p-1
               text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50
               dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]"
        (click)="openDelete(a.agendaId)">
        <svg xmlns="http://www.w3.org/2000/svg" class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="1.2"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
        </svg>
        Eliminar
      </button>

      <button class="flex w-full items-center justify-center gap-1 rounded-lg border border-gray-300 bg-white p-1
               text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50
               dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]"
        (click)="onEditAgenda(a.agendaId)">
        <svg xmlns="http://www.w3.org/2000/svg" class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
        </svg>
        Editar
      </button>
    </div>
  </div>
</div>

@if (!agendas().length) {
<div class="mt-6 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-6 py-6 text-center text-gray-500 dark:border-gray-700 dark:bg-gray-900/40 dark:text-gray-400">
  Aún no se han agregado agendas. Usa el botón <strong>Nueva Agenda</strong> para crear la primera.
</div>
}

<app-modal [open]="open" [title]="modalTitle" [size]="'md'" [bodyComponent]="ScheduleAddForm" [closeOnBackdrop]="false"
  [bodyInputs]="modalBodyInputs" (confirm)="onModalConfirm($event)" (close)="open = false" [isSaving]="isSaving">
</app-modal>

<app-confirm-modal [(open)]="confirmOpen" title="Eliminar agenda!"
  subtitle="Esta acción no se puede deshacer, ¿deseas continuar?." cancelText="No, volver" confirmText="Sí, eliminar"
  variant="danger" [closeOnBackdrop]="true" (confirm)="onConfirmDelete()" (cancel)="toDeleteId = null">
</app-confirm-modal>
